import React from "react";
import { Formik, Field, Form } from "formik";
import { Link } from "react-router-dom";
import { ModalRoute } from "seed/helpers";
import { APP_URL } from "settings";
import l from "components/util/l";
import ProcessPermissionField from "components/util/helpers/ProcessPermissionField";
import CollectionPermissionField from "components/util/helpers/CollectionPermissionField";
import PermissionGridField from "components/util/helpers/PermissionField";
import CustomViews from "components/presentation/settings/CustomViews";
import PreviewFileField from "components/util/helpers/PreviewFileField";
import Roles from "components/presentation/settings/roles/Roles";
import ColorPicker from "components/util/helpers/ColorPicker";
import "styles/css/presentation/Settings.css";

const ChatSettingsView = ({
  user,
  flow,
  chat,
  userUsage,
  flowSettings,
  chatSettings,
  presentationSettings,
  securitySettings,
  flowNodePermissions,
  collectionPermissions,
  permissionTabSelected,
  isAdmin,
  isDeveloper,
  refreshFlow,
  onClickConfiguration,
  onSubmit,
  setPermissionTabSelected
}) => (
  <div className="section-container">
    <div className="card px-5 py-5 my-4">

      <h2 className="mb-3">{l("Configuración%PA110")}</h2>

      <Formik
        initialValues={{
          token: flow.token,
          settings: flowSettings,
          chat_settings: chatSettings,
          presentation_settings: presentationSettings,
          security_settings: securitySettings,
          flow_node_permissions: flowNodePermissions,
          collection_permissions: collectionPermissions,
          primaryColor: flow.theme.primaryColor,
          accentColor: flow.theme.accentColor,
          logo: flow.theme.logo
        }}
        onSubmit={onSubmit}>
        {({ values, setFieldValue }) =>
          <Form>

            <label className="dropdown-header px-0 mb-0 pt-3 text-dark">{l("Ajustes generales%PA109")}</label>
            <div className="d-flex">
              <Link
                to="/edit_flow"
                className="btn btn-lighter-white mt-1 mr-2">
                <i className="fas fa-edit mr-2"></i>
                {l("Editar solución%PA108")}
              </Link>
              <a
                onClick={onClickConfiguration}
                className="btn btn-lighter-white mt-1">
                <i className="fas fa-cog mr-2"></i>
                {l("Configuración global%PA088")}
              </a>
            </div>

            {
              isAdmin &&
              <div>
                <hr className="mt-5 mb-4" />
                <label className="dropdown-header px-0 pt-3 text-dark">{l("Permisos%PA107")}</label>

                <div className="mb-3">
                  <div className="tabs d-flex mb-4">
                    <button
                      type="button"
                      className={"dropdown-header py-2 " + (permissionTabSelected == "GENERAL" ? "active" : "")}
                      style={{ fontSize: "0.85em" }}
                      onClick={() => setPermissionTabSelected("GENERAL")}
                    >
                      {l("General%GA097")}
                    </button>
                    <button
                      type="button"
                      className={"dropdown-header py-2 " + (permissionTabSelected == "PROCESSES" ? "active" : "")}
                      style={{ fontSize: "0.85em" }}
                      onClick={() => setPermissionTabSelected("PROCESSES")}
                    >
                      {l("Procesos%GA095")}
                    </button>
                    <button
                      type="button"
                      className={"dropdown-header py-2 " + (permissionTabSelected == "DATA" ? "active" : "")}
                      style={{ fontSize: "0.85em" }}
                      onClick={() => setPermissionTabSelected("DATA")}
                    >
                      {l("Datos%GA096")}
                    </button>
                  </div>
                </div>

                {
                  permissionTabSelected === "GENERAL" &&
                  <>
                    <PermissionGridField
                      flowId={flow.id}
                      fields={[
                        { name: 'chat_settings.permissions.show_share', label: l('Configurar accesos%PA175', 'Aa') },
                        { name: 'chat_settings.permissions.show_sidenav', label: l('Mostrar menú lateral%PA089', 'Aa') },
                        ...(presentationSettings?.views?.map(view => ({
                          name: "chat_settings.permissions.show_" + view.name,
                          label: `${l("Mostrar sección%PA091")} - ${view.is_prebuilt ? l(view.label) : view.label} `,
                        })) || []),
                        { name: "chat_settings.permissions.show_manage_collections", label: l("Configurar tablas%PA092") },
                      ]}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                  </>
                }

                {
                  permissionTabSelected === "PROCESSES" &&
                  <>
                    {
                      values.flow_node_permissions.map((node, index) => <>
                        <label className="dropdown-header px-0 pt-2 pb-0 text-dark" key={`node-${index}`}>
                          {node.name}
                        </label>
                        <div className="mt-n2 pb-2">
                          <ProcessPermissionField
                            flowId={flow.id}
                            values={values.flow_node_permissions[index].settings || {}}
                            setFieldValue={(field, value) => {
                              setFieldValue(`flow_node_permissions[${index}].settings.${field}`, value);
                            }}
                          />
                        </div>
                      </>)
                    }
                  </>
                }

                {
                  permissionTabSelected === "DATA" &&
                  <>
                    {
                      values.collection_permissions.map((collection, index) => <>
                        <label className="dropdown-header px-0 pb-0 text-dark" key={`collection-${index}`}>
                          {collection.name}
                        </label>
                        <div className="mt-n2 pb-2">
                          <CollectionPermissionField
                            flowId={flow.id}
                            values={values.collection_permissions[index].settings || {}}
                            setFieldValue={(field, value) => {
                              setFieldValue(`collection_permissions[${index}].settings.${field}`, value);
                            }}
                          />
                        </div>
                      </>)
                    }
                  </>
                }

              </div>
            }

            {["ENTERPRISE"].includes(userUsage?.license?.category?.name) && (
              <div className="w-100 text-right">
                <Link
                  to="/roles"
                  className="btn btn-link mb-4"
                >
                  <i className="fas fa-user-group mr-2"></i>
                  {l("Personalizar roles%PA072")}
                </Link>
              </div>
            )}

            {
              <div>
                <hr className="mt-1 mb-3" />
                <label className="dropdown-header px-0 mb-2 pt-3 text-dark">{l("Ajustes visuales%PA174")}</label>
                <Link
                  to="/custom"
                  className="btn btn-lighter-white mb-4"
                >
                  <i className="fas fa-window-maximize mr-2"></i>
                  {l("Editar secciones%PA075")}
                </Link>
              </div>
            }

            <div className="mb-2">
              <ColorPicker
                className="d-inline-block"
                label={l("Color principal%VG094")}
                name="primaryColor"
                values={values}
                defaultColor={"#2065a5"}
                setFieldValue={setFieldValue}
              />

              <ColorPicker
                className="d-inline-block"
                label={l("Color de acento%VG095")}
                name="accentColor"
                values={values}
                defaultColor={"#f0b000"}
                setFieldValue={setFieldValue}
              />

              <div className="d-flex align-items-center mt-3">
                <label class="avatar avatar-xl avatar-uploader mr-5" for="logo-uploader" style={{ width: "auto" }}>
                  <img
                    id="logo-image"
                    class="avatar-img"
                    src={(values?.logo != null && values?.logo != "") ? values.logo : "/theme/img/160x160/img1.jpg"}
                    alt="Custom logo"
                  />
                  <PreviewFileField
                    name="logo"
                    id="logo-uploader"
                    required={true}
                    className="js-file-attach avatar-uploader-input"
                    accept=".jpg,.jpeg,.svg,.png,.gif,.bmp,.webp"
                    hsFileAttachOptions={`{
                                "textTarget": "#logo-image",
                                "mode": "image",
                                "targetAttr": "src",
                                "resetTarget": ".js-file-attach-reset-img",
                                "resetImg": "/theme/img/160x160/img1.jpg"
                              }`}
                    setFieldValue={() => { }}
                    onCompleted={(data) => setFieldValue("logo", data?.url)}
                  />
                  <span class="avatar-uploader-trigger">
                    <i class="tio-edit avatar-uploader-icon shadow-soft"></i>
                  </span>
                </label>
                <button type="button" class="js-file-attach-reset-img btn btn-white" onClick={() => setFieldValue("logo", null)}>
                  <i className="fas fa-trash mr-2"></i>{l("Eliminar%GA001")}
                </button>
              </div>

            </div>

            {
              isDeveloper &&
              <div>
                <hr className="mt-5 mb-4" />
                <label className="dropdown-header px-0 pt-3 text-dark">{l("Enlace personalizado%PA094")}</label>
                <div className="form-group mb-4">
                  <span>{APP_URL}/app/</span>
                  <Field
                    id="token-input"
                    type="text"
                    name="token"
                    maxlength="21"
                    className="form-control d-inline-block ml-1 px-2"
                  />
                </div>
              </div>
            }

            {
              isDeveloper &&
              <div>
                <hr className="mt-5 mb-4" />
                <label className="dropdown-header px-0 pt-3 text-dark">{l("Credenciales de acceso%PA095")}</label>

                <SecretField
                  label="OpenAI Token"
                  name="security_settings.openai.api_key"
                  value={values.security_settings?.openai?.api_key || ""}
                />

                <SecretField
                  label="DeepSeek Token"
                  name="security_settings.deepseek.api_key"
                  value={values.security_settings?.deepseek?.api_key || ""}
                />

                <SecretField
                  label="Gemini Token"
                  name="security_settings.gemini.api_key"
                  value={values.security_settings?.gemini?.api_key || ""}
                />

                <SecretField
                  label="Twilio SID"
                  name="security_settings.twilio.sid"
                  value={values.security_settings?.twilio?.sid || ""}
                />

                <SecretField
                  label="Twilio Token"
                  name="security_settings.twilio.token"
                  value={values.security_settings?.twilio?.token || ""}
                />

                <SecretField
                  label="Twilio WhatsApp"
                  name="security_settings.twilio.whatsapp"
                  value={values.security_settings?.twilio?.whatsapp || ""}
                />

                <SecretField
                  label="LLM Host"
                  name="security_settings.custom.host"
                  value={values.security_settings?.custom?.host || ""}
                />

              </div>
            }

            <button type="submit" class="btn btn-primary font-weight-bold w-100 mt-4">{l("Guardar%GA023")}</button>

          </Form>}
      </Formik>

      <ModalRoute
        path="/custom"
        width={800}
        height={window.innerHeight - 100}
        flow={flow}
        chat={chat}
        refreshFlow={refreshFlow}
        component={CustomViews}
      />

      <ModalRoute
        path="/roles"
        width={750}
        height={600}
        flow={flow}
        onSubmit={onSubmit}
        chatSettings={chatSettings}
        component={Roles}
      />

    </div>
  </div>
);

const SecretField = ({ label, name, value }) => {
  const isSecret = value === "__SECRET__";

  return (
    <div className="form-group mb-4">
      <label>{label}</label>
      <Field
        id="token-input"
        type="password"
        name={name}
        className="form-control d-inline-block ml-2 px-2"
        placeholder={isSecret ? "******" : "Sin configurar"}
        value={isSecret ? "" : value}
      />
    </div>
  );
};

export default ChatSettingsView;